// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSListDetailContainer/DetailRight.less
// module id = 1145
// module chunks = 42